<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12">
      <hr />
    </div>
    <div class="col-sm-12 col-xs-12 team-wrapper">
      <div class="col-xs-12 col-sm-6 col-sm-push-6">
        <div class="col-xs-12 col-sm-10" style="padding-top: 10px; text-align: center">
          <img class="new_member_img" src="/static/images/icons/blank_image.svg" alt="blank-icon" />
        </div>
      </div>
      <div class="col-sm-6 col-sm-pull-6 col-xs-12">
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">First Name</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="First Name"
              class="form-control"
              v-model="team.first_name"
              maxlength="35"
            />
          </div>
        </div>
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">Last Name</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Last Name"
              class="form-control"
              v-model="team.last_name"
              maxlength="35"
            />
          </div>
        </div>
        <!-- :class="displayEmailErrorMsg || addMemberError.length ? 'mr-bt-6p' : 'mr-bt-5p'" -->
        <div
          class="row"
          :class="displayEmailErrorMsg || addMemberError ? 'mr-bt-0p' : 'mr-bt-5p'"
        >
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">Email</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Email"
              class="form-control"
              :class="displayEmailErrorMsg || addMemberError ? 'invalid-border' : ''"
              v-model="team.email"
              maxlength="65"
              @blur="emailVal"
            />
            <div
              v-if="addMemberError"
              class="validation-message"
              style="padding-left: 2px; font-size: 14px; float: left"
            >
              {{ addMemberError }}
            </div>
            <div v-show="displayEmailErrorMsg" class="custom-error-class">
              <span>Invalid email.</span>
            </div>
          </div>
        </div>
        <div
          class="row"
          :class="displayIpErrorMsg ? 'mr-bt-0p' : 'mr-bt-5p'"
          v-if="multi_factor_key"
        >
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">IP Address</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="IP Address (xxx.xxx.xxx.xxx)"
              class="form-control"
              :class="displayIpErrorMsg ? 'invalid-border' : ''"
              v-model="team.ip_address"
              @blur="ipAddressVal"
            />
            <div v-if="displayIpErrorMsg" class="custom-error-class">
              <span>Invalid IP Address.</span>
            </div>
          </div>
        </div>
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">Role</div>
          <div class="col-sm-12 col-xs-12 col-md-10 custom-dropdown">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :class="!team.role ? 'un-selected' : ''"
              :searchable="false"
              :options="roles.map((role) => role.id)"
              :custom-label="getRoleNameById"
              v-model="team.role"
              @input="getRoleBasedTemplate(team.role)"
              placeholder="Select Role"
            >
            </multiselect>
          </div>
        </div>
        <div class="row mr-bt-5p" v-if="team.role == '6'">
          <div class="col-sm-12 col-xs-12 col-md-12">Distributor</div>
          <div class="col-sm-12 col-xs-12 col-md-10 custom-dropdown">
            <multiselect
              :disabled="team.role != '6'"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :searchable="false"
              :options="localDistributors.map((distributor) => distributor.id)"
              :custom-label="
                (option) => localDistributors.find((x) => x.id === option).distributor_name
              "
              v-model="team.assigned_distributor_id"
              placeholder="Select distributor"
            >
            </multiselect>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 pb-20" v-if="userServiceList.length">
        <div class="col-md-12 col-sm-12 col-xs-12 bt-border">
          <div class="row">
            <div class="col-sm-7 col-xs-6">Services access</div>
            <div class="col-sm-3 col-xs-6 txt-alg-rt">Permissions</div>
          </div>
        </div>
        <div
          v-for="(service, index) in userServiceList"
          :key="index"
          class="col-md-12 col-sm-12 col-xs-12 bt-border"
        >
          <div class="row pb-8 pt-8" v-if="service.key != 'REPRESENTATION_RESOURCES' || account_type_id != 3">
            <div class="col-sm-7 col-xs-8 d-flex align-items-center">
              <span
                class="checkbox mr-12"
                :class="{ 'link-disabled': !disablePermissionCheck(service.id) }"
              >
                <label>
                  <input
                    type="checkbox"
                    class="form-control"
                    v-model="service.access"
                    :disabled="!disablePermissionCheck(service.id)"
                    @change="revertOldPermissions(service.id, service.access)"
                  />
                  <span class="cr"></span>
                </label>
              </span>
              <span
                class="cust_label"
                :class="{ 'link-disabled': !disablePermissionCheck(service.id) }"
              >
                {{ service.name }}
              </span>
            </div>
            <div class="col-sm-3 col-xs-4">
              <div
                class="edit-lnk"
                @click="
                  disablePermissionCheck(service.id) && service.access
                    ? openPermissionsPopup(service)
                    : null
                "
                :class="{ 'link-disabled': !disablePermissionCheck(service.id) || !service.access }"
              >
                edit
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding">
      <div class="col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
        <button type="button" class="btn btn-block emergo-white-button" @click="cancelAddTeam">
          Cancel
        </button>
      </div>
      <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
        <button
          type="button"
          class="btn btn-block emergo-green-button"
          @click="addTeamMember"
          :disabled="disableButtonForAddTeam || loaderStatus"
        >
          Save/Add
        </button>
      </div>
    </div>
    <member-permissions
      :memberName="memberName"
      :serviceId="serviceId"
      :userServiceList="userServiceList"
      :rolesServicesList="servicesList"
      @updateUserPermission="updateUserPermission"
    ></member-permissions>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import Loader from '../../UIComponents/Loader.vue';
import EventBus from '../../../utils/event-bus';
import MemberPermissions from './MemberPermissions.vue';
import { addTeamMember, getAccountOwnersCount } from '../../../apis/team';
import { getRoleBasedPermissions } from '../../../apis/rbac';
import { getAddonDetails } from '../../../apis/psm';
import { getActiveServices } from '../../../apis/marketPlace';
import { isDefaultAvailable } from '../../../apis/regulatoryIntelligence';

export default {
  props: ['roles', 'localDistributors', 'multi_factor_key', 'account_type_id'],
  data() {
    return {
      displayEmailErrorMsg: false,
      displayIpErrorMsg: false,
      team: {
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        assigned_distributor_id: null,
        ip_address: ''
      },
      addMemberError: '',
      loaderStatus: false,
      servicesList: [],
      serviceId: null,
      memberName: '',
      userServiceList: [],
      addedServiceIds: []
    };
  },
  components: {
    MemberPermissions,
    Loader
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    removeNull(array) {
      return array.filter((item) => item);
    },
    disablePermissionCheck(serviceid) {
      return this.servicesList.find((service) => service.id === serviceid).access;
    },
    updateUserPermission(permissions, serviceId) {
      this.userServiceList.forEach((service, index) => {
        if (service.id === serviceId) {
          this.userServiceList[index] = permissions;
        }
      });
    },
    revertOldPermissions(id, access) {
      if (!access) {
        const oldService = this.servicesList.find((service) => service.id === id);
        this.userServiceList.forEach((service, index) => {
          if (service.id === id) {
            this.userServiceList[index].access = access;
            this.userServiceList[index].modules = oldService.modules;
          }
        });
      }
    },
    emailVal() {
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; //eslint-disable-line
      this.displayEmailErrorMsg = false;
      if (this.team.email && !this.team.email.match(mailformat)) {
        this.displayEmailErrorMsg = true;
      }
    },
    ipAddressVal() {
      const ipAddressFormat =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
      this.displayIpErrorMsg = false;
      if (this.team.ip_address && !this.team.ip_address.match(ipAddressFormat)) {
        this.displayIpErrorMsg = true;
      }
    },
    dateFormatForExpiry(date) {
      return moment.utc(date).format('YYYY-MM-DD');
    },
    async validateTeamUpgrade() {
      this.loaderStatus = true;
      const addonAccountDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      this.recordAddonService = addonAccountDetails.find((each) => each.units === 'RECORDS');
      this.teamAddonService = addonAccountDetails.find((each) => each.units === 'USERS');
      this.loaderStatus = false;
      if (this.teamAddonService) {
        if (
          this.teamAddonService.total_limit >= this.teamAddonService.default_limit &&
          this.teamAddonService.is_active &&
          moment().utc().format('YYYY-MM-DD') <=
            this.dateFormatForExpiry(this.teamAddonService.valid_until) &&
          moment().utc().format('YYYY-MM-DD') >=
            this.dateFormatForExpiry(this.teamAddonService.valid_from)
        ) {
          this.max_team_members = this.teamAddonService.total_limit;
        } else if (
          this.teamAddonService.total_limit >= this.teamAddonService.default_limit &&
          this.teamAddonService.is_active &&
          moment().utc().format('YYYY-MM-DD') >
            this.dateFormatForExpiry(this.teamAddonService.valid_until) &&
          moment().utc().format('YYYY-MM-DD') >=
            this.dateFormatForExpiry(this.teamAddonService.valid_from)
        ) {
          this.max_team_members = this.teamAddonService.default_limit;
        }
        this.current_members = this.teamAddonService.current_utilization;
      }
    },
    async addTeamMember() {
      await this.validateTeamUpgrade();
      if (this.current_members < this.max_team_members) {
        if (await this.checkAccountOwnersCount()) {
          this.loaderStatus = true;
          this.addMemberError = '';
          const data = {
            first_name: this.team.first_name,
            last_name: this.team.last_name,
            memberEmailId: this.team.email,
            roleAssigned: this.team.role,
            rbac_permission_inst: this.userServiceList,
            ip_address: this.team.ip_address
          };
          if (this.team.assigned_distributor_id)
            data.assigned_distributor_id = this.team.assigned_distributor_id;
          const response = await addTeamMember(data);
          this.loaderStatus = false;
          if (response.status) {
            this.clearNotifications();
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Member added successfully!',
              group: 'custom-notification'
            });
            this.$emit('getTeamMembers');
            this.cancelAddTeam();
          } else {
            this.addMemberError = response.message;
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: 'Error',
              text: response.message || 'Unable to save Team member!',
              group: 'custom-notification'
            });
          }
        }
      }
      $(`#${this.genericPopupId}`).modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async checkAccountOwnersCount() {
      if (
        this.account_type_id !== 1 &&
        this.account_type_id !== 5 &&
        (this.team.role === 1 || this.team.role === 9)
      ) {
        this.loaderStatus = true;
        const response = await getAccountOwnersCount(this.account_type_id);
        this.loaderStatus = false;
        if (!response) {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Unable to fetch Account Owners Count!',
            group: 'custom-notification'
          });
          return false;
        }
        if (response.count < 5) {
          return true;
        }
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Maximum 5 account owners can be added!',
          group: 'custom-notification'
        });
        return false;
      }
      return true;
    },
    cancelAddTeam() {
      this.displayEmailErrorMsg = false;
      this.displayIpErrorMsg = false;
      this.team = {
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        assigned_distributor_id: null,
        ip_address: ''
      };
      this.addTeamFlag = false;
      this.teamPermissionsFlag = false;
      this.$emit('cancelAddTeam');
      this.memberName = '';
      this.serviceId = null;
      this.userServiceList = [];
    },
    openPermissionsPopup(service) {
      this.serviceId = service.id;
      this.memberName = `${this.team.first_name} ${this.team.last_name}`;
      setTimeout(() => {
        $('#permissionsAccess').modal({
          backdrop: 'static',
          keyboard: false
        });
      }, 0);
    },
    async getRoleBasedTemplate(roleId) {
      await this.getSubscribedPlans();
      this.loaderStatus = true;
      const response = await getRoleBasedPermissions(roleId);
      this.loaderStatus = false;
      if (response) {
        const updatedResponse = this.removeNull(response.services).map((x) => ({
          ...x,
          modules: this.removeNull(x.modules).map((m) => ({
            ...m,
            operations: this.removeNull(m.operations)
          }))
        }));
        response.services = updatedResponse;
        response.services.forEach((service, serviceIndex) => {
          if (service.service_id && !this.addedServiceIds.includes(service.service_id)) {
            // To validate whether service is accessable or not
            response.services[serviceIndex].access = false;
          }
        });
        if (this.account_type_id === 3) {
          response.services = response.services.map((service) => {
            if (service.key === 'REPRESENTATION_RESOURCES') service.access = false;
            return service;
          });
        }
        this.servicesList = cloneDeep(response.services);
        this.userServiceList = cloneDeep(this.servicesList);
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to get default permissions for the role!',
          group: 'custom-notification'
        });
      }
      await getAccountOwnersCount(this.account_type_id);
    },
    removeAssignedDistributorId() {
      this.team.assigned_distributor_id = null;
    },
    async getSubscribedPlans() {
      this.loaderStatus = true;
      const accoountServices = await getActiveServices(localStorage.getItem('accountId'));
      this.addedServiceIds = accoountServices.services || [];
      if (!this.addedServiceIds.includes(2)) {
        // Validate when Reg Intel market not active
        const isDefaultMarket = await isDefaultAvailable(localStorage.getItem('accountId'));
        if (isDefaultMarket) {
          this.addedServiceIds.push(2);
        }
      }
    },
    getRoleNameById(id) {
      const role = this.roles.find((r) => r.id === id);
      return role ? role.name : '';
    }
  },
  created() {
    EventBus.$on('resetTeams', () => {
      this.cancelAddTeam();
    });
  },
  beforeDestroy() {
    EventBus.$off('resetTeams');
  },
  computed: {
    disableButtonForAddTeam() {
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; //eslint-disable-line
      const ipAddressFormat =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
      if (
        this.team.last_name &&
        this.team.first_name &&
        this.team.email &&
        this.team.email.match(mailformat) &&
        this.team.role &&
        this.team.role === 6 &&
        this.team.assigned_distributor_id
      ) {
        if (this.team.ip_address && !this.team.ip_address.match(ipAddressFormat)) {
          return true;
        }
        return false;
      }
      if (
        this.team.last_name &&
        this.team.first_name &&
        this.team.email &&
        this.team.email.match(mailformat) &&
        this.team.role &&
        this.team.role !== 6
      ) {
        this.removeAssignedDistributorId();
        if (this.team.ip_address && !this.team.ip_address.match(ipAddressFormat)) {
          return true;
        }
        return false;
      }
      if (this.team.role && this.team.role !== 6) {
        this.removeAssignedDistributorId();
        return true;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.team-wrapper {
  height: 55vh;
  overflow: auto;
}
.mr-bt-5p {
  margin-bottom: 5%;
  padding-bottom: 4px;
}
.mr-bt-0p {
  margin-bottom: 0%;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.bt-border {
  border-bottom: 1px solid $gray74;
  border-bottom: 1px solid $gray74;
}
.txt-alg-rt {
  text-align: right;
}
.edit-lnk {
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  font-size: $font-16;
  text-align: right;
  padding-right: 15%;
  color: $messenger-blue;
  cursor: pointer;
}
.cust_label {
  font-size: $font-14;
  color: $primary;
  font-weight: $font-weight-medium;
}
.custom-error-class {
  display: inline-block;
  margin-top: 0px;
}
.link-disabled {
  opacity: 0.4;
}
.multiselect-single-dropdown {
  ::v-deep .multiselect__content-wrapper {
    max-height: 270px !important;
  }
}
@media screen and (max-width: 767px) {
  .bt-border {
    padding-bottom: 10px;
  }
}
@media screen and (min-width: 768px) {
  .hide-sm {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .team-wrapper {
    height: 45vh;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .team-wrapper {
    height: 52vh;
  }
}

/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .team-wrapper {
    height: 45vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .team-wrapper {
    height: 48vh;
  }
}
</style>
